// Modules
import { theme } from '@dasa-health/components-react'
import styled from 'styled-components'

export const StyledHeader = styled.div<{ inline?: boolean }>`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    max-width: 434px;
    width: 100%;

    > header {
        display: flex;
        justify-content: flex-start;
        gap: 24px;
    }
    .divider {
        display: flex;
        width: 1px;
        background: #dadada;
        height: 20px;
    }

    &.Header--with-logo > header {
        max-height: 85px;
    }

    .header__image {
        height: 20px;
        display: block;
    }

    .header__title {
        margin-top: 1.375rem;
        margin-bottom: 1rem;
        font-size: 1.5rem;
        line-height: 1.5em;
    }

    p span {
        display: inline-block;
    }

    .header__subtitle {
        display: ${({ inline }) => (inline ? 'inline' : 'flex')};
        align-items: center;
        margin-bottom: ${theme.space[4]};

        & > p {
            display: ${({ inline }) => (inline ? 'inline' : 'initial')};
        }

        & > span {
            font-weight: ${theme.fontWeights.bold};
            display: inline-block;
            padding-right: ${theme.space[2]};
        }
    }

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;

        .divider {
            height: 24px;
        }

        .header__image {
            height: 24px;
        }

        &.Header--with-brand {
            margin-top: 64px;
        }

        &.Header--with-logo {
            margin-top: 39px;
        }

        .logo-alta {
            margin-left: 0;
        }
    }
`
